module.exports = __webpack_public_path__ + "static/img/right.d8e7f4aa.png";